const attachmentTypes = {
  VARIABLE: "variable",
  FILE: "file",
} as const;

export { attachmentTypes };
